import React, { useState } from 'react'

import { PlusOutlined, UploadOutlined, QuestionCircleFilled } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import ListPageHeader from '@shared/ListPageHeader'
import ReturnOrdersList from '@shared/return_orders/ReturnOrdersList'
import OperatorReturnOrderConceptModal from '@shared/return_orders/OperatorReturnOrderConceptModal'

import { returnOrderService } from '@services/operator/returnOrderService'

export default function OperatorReturnOrdersList() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { merchants } = useOperatorData()
  const isStandard = useIsStandard()
  const { addJob } = useOperatorNotification()
  const [importModalVisible, setImportModalVisible] = useState(false)
  const [conceptModalVisible, setConceptModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        items={['returns', 'returns.list']}
        guideButton={
          <Tooltip title={t('concepts.return_orders_operator.tooltip')}>
            <Button
              type="text"
              size="small"
              icon={<QuestionCircleFilled style={{ color: '#1890ff' }} />}
              onClick={() => setConceptModalVisible(true)}
              style={{ padding: 0, height: 'auto', minWidth: 'auto' }}
            />
          </Tooltip>
        }
        actions={
          <>
            <Button icon={<UploadOutlined />} onClick={() => setImportModalVisible(true)}>
              {t('common.button.import')}
            </Button>
            <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/return_orders/new')}>
              {t('common.button.new')}
            </Button>
          </>
        }
      />
      <ReturnOrdersList
        service={returnOrderService}
        role="operator"
        showMerchantColumn={!isStandard}
        merchants={merchants}
        addJob={addJob}
        importModalVisible={importModalVisible}
        setImportModalVisible={setImportModalVisible}

      />
      <OperatorReturnOrderConceptModal
        visible={conceptModalVisible}
        onClose={() => setConceptModalVisible(false)}
      />
    </div>
  )
}
